import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import './ButtonBack.css';

export function ButtonBack() {
  const navigate = useNavigate();

  return (
    <div className="buttonBack">
      {!isMobile && (
        <button
          type="button"
          className="buttonTextWithIconGoBack"
          onClick={() => navigate('/')}
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
            size="sm"
            color="#1351b4"
            style={{ marginRight: '8px' }}
          />
          Voltar
        </button>
      )}
    </div>
  );
}
